import React from 'react'
import Skeleton from 'components/skeleton'
import PageHeader from 'components/pageHeader'

// What a document shows until it arrives: its header and a few sections of
// placeholder text, laid out as the loaded document is, so nothing jumps when
// it lands.

// Line widths for each placeholder section's paragraph.
const SECTIONS = [
  ['96%', '88%', '92%', '60%'],
  ['90%', '94%', '72%'],
  ['85%', '92%', '89%', '45%']
]

const DocumentSkeleton: React.FC = () => (
  <div className="flex flex-col w-full h-full overflow-hidden bg-surface text-body">
    <div className="@container/document shrink-0">
      <PageHeader name="" testIdPrefix="document-loading" loading />
    </div>
    <div
      className="mt-[30px] mb-[75px] mx-[150px] max-lg:mt-10 max-lg:mx-[30px] flex flex-col gap-10"
      role="status"
      aria-label="Loading document"
      data-testid="document-loading"
    >
      <Skeleton className="block h-7 w-2/5" />
      {SECTIONS.map((lines, section) => (
        <div key={section} className="flex flex-col gap-3">
          <Skeleton className="block h-5 w-1/4" />
          {lines.map((width, line) => (
            <Skeleton key={line} className="block h-3" style={{ width }} />
          ))}
        </div>
      ))}
    </div>
  </div>
)

export default DocumentSkeleton
